import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import { motion } from 'framer-motion';
import { Star, ChevronRight, ArrowRight } from 'lucide-react';
import Logo from '../Components/Images/Bada school logo.png';
import PrincipalImg from '../Components/Images/Picture 1.jpeg';

export default function Home() {
  const [homeImages, setHomeImages] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/getHomeImages`)
      .then(response => {
        const raw = response.data?.data ?? response.data;
        setHomeImages(Array.isArray(raw) ? raw : []);
      })
      .catch(error => {
        console.error('Error fetching home images:', error);
        setHomeImages([]);
      });
  }, []);

  const facilities = [
    { name: "Activity Playroom", desc: "Colorful space equipped with blocks, slides, and educational toys.", icon: "🎪", color: '#e0f2fe' },
    { name: "Digital Classroom", desc: "Modern visual setup introducing letters, math and languages dynamically.", icon: "🖥️", color: '#fef9c3' },
    { name: "School Library", desc: "Preschool storybooks, picture references and vocabulary charts.", icon: "📚", color: '#ffe4e6' },
    { name: "Creative Art Corner", desc: "Painting stands, clay crafting tools and musical circles.", icon: "🎨", color: '#dcfce7' }
  ];

  return (
    <div style={{ position: 'relative', overflowX: 'hidden' }}>
      {/* Global scrapbook floating doodles */}
      <div style={{ position: 'absolute', top: '2%', left: '3%', fontSize: '2.5rem', opacity: 0.15 }} className="cloud-float">☁️</div>
      <div style={{ position: 'absolute', top: '15%', right: '5%', fontSize: '2rem', opacity: 0.12 }} className="float-slow">✏️</div>
      <div style={{ position: 'absolute', top: '25%', left: '8%', fontSize: '2.5rem', opacity: 0.15 }} className="plane-float">🪁</div>
      <div style={{ position: 'absolute', top: '35%', right: '12%', fontSize: '2.2rem', opacity: 0.12 }}>📚</div>
      <div style={{ position: 'absolute', top: '48%', left: '2%', fontSize: '2rem', opacity: 0.15 }} className="cloud-float">✨</div>
      <div style={{ position: 'absolute', top: '55%', right: '8%', fontSize: '2.8rem', opacity: 0.15 }} className="float-slow">🌈</div>
      <div style={{ position: 'absolute', top: '65%', left: '6%', fontSize: '2.5rem', opacity: 0.15 }} className="plane-float">✈️</div>
      <div style={{ position: 'absolute', top: '75%', right: '15%', fontSize: '2.2rem', opacity: 0.12 }} className="float-slow">🧸</div>
      <div style={{ position: 'absolute', top: '82%', left: '4%', fontSize: '2.5rem', opacity: 0.15 }} className="cloud-float">🍎</div>
      <div style={{ position: 'absolute', top: '90%', right: '6%', fontSize: '2rem', opacity: 0.15 }}>🖍️</div>
      <div style={{ position: 'absolute', bottom: '4%', left: '10%', fontSize: '2.5rem', opacity: 0.18 }} className="sun-spin">☀️</div>
      <div style={{ position: 'absolute', bottom: '2%', right: '4%', fontSize: '2rem', opacity: 0.15 }} className="cloud-float">☁️</div>


      {/* 1. Hero Section (Blue + Yellow Gradient Backdrop) */}
      <section style={{ ...sectionStyle, background: 'linear-gradient(135deg, #e0f2fe 0%, #fef9c3 100%)', minHeight: '95vh', display: 'flex', alignItems: 'center' }}>

        {/* Twinkling stars & floating objects background details */}
        <div className="sun-spin" style={{ position: 'absolute', top: '12%', right: '8%', fontSize: '4.5rem', opacity: 0.18, zIndex: 1 }}>☀️</div>
        <div className="cloud-float" style={{ position: 'absolute', top: '20%', left: '10%', fontSize: '3rem', opacity: 0.25, zIndex: 1 }}>☁️</div>
        <div className="plane-float" style={{ position: 'absolute', bottom: '25%', left: '8%', fontSize: '2.5rem', opacity: 0.2, zIndex: 1 }}>✈️</div>

        <div className="page-container-wide" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '48px', alignItems: 'center', position: 'relative', zIndex: 5 }}>
          {/* Hero Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 20px', backgroundColor: 'var(--accent-coral)', color: '#ffffff', borderRadius: '9999px', fontSize: '0.85rem', fontWeight: 800, textTransform: 'uppercase', marginBottom: '24px', letterSpacing: '1px', boxShadow: '0 4px 10px rgba(251,113,133,0.2)' }}>
              <Star size={14} fill="#ffffff" /> Admissions Open 2026-27
            </div>

            <h1 style={{ fontSize: '3.5rem', color: 'var(--text-primary)', lineHeight: '1.15', marginBottom: '24px', fontFamily: 'Poppins', fontWeight: 800 }}>
              Where Young Minds <span style={{ color: 'var(--primary-dark)' }}>Bloom & Play!</span>
            </h1>

            {/* Principal Quote */}
            <div style={{ borderLeft: '6px solid var(--primary-color)', paddingLeft: '20px', margin: '28px 0', fontStyle: 'italic', color: 'var(--text-secondary)', fontSize: '1.05rem', backgroundColor: 'rgba(255,255,255,0.4)', padding: '16px 20px', borderRadius: '0 16px 16px 0' }}>
              "Dream requires sound sleep, and Aim requires sleepless effort to fulfill."
              <p style={{ fontWeight: 700, margin: '8px 0 0 0', fontSize: '0.9rem', color: 'var(--text-primary)', notStyle: 'normal' }}>– Principal</p>
            </div>

            <p style={{ color: 'var(--text-secondary)', fontSize: '1.2rem', marginBottom: '36px', fontFamily: 'Quicksand', fontWeight: 700, lineHeight: '1.6' }}>
              Vamshee Techno School welcomes children into a vibrant, nurturing environment that fosters creative thinking, sensory exploration, and early cognitive foundation.
            </p>

            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <a href="/Apply" className="btn-premium btn-premium-primary" style={{ textDecoration: 'none' }}>
                Register Online <ArrowRight size={18} />
              </a>
              <a href="#about-section" className="btn-premium btn-premium-secondary" style={{ textDecoration: 'none' }}>
                Explore Curriculum
              </a>
            </div>
          </motion.div>

          {/* Hero Right Visuals */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
          >
            {/* Single Large School Logo with Abstract Rings */}
            <div style={{ position: 'relative', width: '100%', maxWidth: '380px', aspectRatio: '1/1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ position: 'absolute', width: '120%', height: '120%', borderRadius: '50%', border: '4px dashed var(--primary-color)', opacity: 0.3 }} className="sun-spin" />
              <div style={{ position: 'absolute', width: '110%', height: '110%', borderRadius: '50%', border: '4px dotted var(--accent-coral)', opacity: 0.4 }} className="float-slow" />

              <div style={{ width: '100%', height: '100%', borderRadius: '50%', backgroundColor: '#ffffff', border: '16px solid #ffffff', overflow: 'hidden', boxShadow: 'var(--shadow-lg)', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', zIndex: 2 }} className="float-slow">
                <img src={Logo} alt="Vamshee Techno School Logo" style={{ width: '90%', height: '90%', objectFit: 'contain' }} />
              </div>

              {/* Floating micro educational elements */}
              <div style={{ position: 'absolute', top: '-10px', left: '-10px', fontSize: '2.5rem', zIndex: 3 }} className="float-slow">✏️</div>
              <div style={{ position: 'absolute', bottom: '-10px', right: '-10px', fontSize: '2.5rem', zIndex: 3 }}>🎒</div>
              <div style={{ position: 'absolute', top: '20%', right: '-40px', fontSize: '2.2rem', zIndex: 3 }} className="cloud-float">☁️</div>
            </div>

            {/* Bouncing Bus floating decor */}
            <div style={floatingBusStyle} className="bus-bounce">🚌 VTS Express</div>
          </motion.div>
        </div>
      </section>

      {/* SVG Transition Wave 1 (Transitions to Lavender for Principal Message) */}
      <div style={waveWrapperStyle}>
        <svg viewBox="0 0 1440 120" style={svgStyle} preserveAspectRatio="none">
          <path d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,42.7C1120,32,1280,32,1360,32L1440,32L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" fill="#faf5ff"></path>
        </svg>
      </div>

      {/* 2. Principal Message & Leadership Section (Lavender Background) */}
      <section style={{ ...sectionStyle, background: 'var(--bg-gallery)', paddingTop: '40px' }}>

        {/* Floating pencil & book icons */}
        <div style={{ position: 'absolute', top: '15%', left: '10%', fontSize: '2rem', opacity: 0.15 }}>✏️</div>
        <div style={{ position: 'absolute', bottom: '20%', right: '15%', fontSize: '2.5rem', opacity: 0.15 }} className="float-slow">📚</div>

        <div className="page-container-wide" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '48px', alignItems: 'center' }}>
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <div style={{ borderRadius: 'var(--border-radius-img)', overflow: 'hidden', boxShadow: '0 20px 48px rgba(167,139,250,0.2)', border: '10px solid #ffffff', width: '100%' }} className="organic-mask-1">
              <img src={PrincipalImg} alt="Principal Portrait" style={{ width: '100%', height: 'auto', display: 'block' }} />
            </div>
            <div style={{ backgroundColor: 'var(--accent-purple)', color: '#ffffff', padding: '16px 28px', borderRadius: 'var(--border-radius-card)', boxShadow: 'var(--shadow-md)', marginTop: '20px', textAlign: 'center', width: 'fit-content' }}>
              <h4 style={{ color: '#ffffff', margin: 0, fontSize: '1.25rem', fontFamily: 'Poppins', fontWeight: 800 }}>Principal</h4>
              <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.9, fontWeight: 700 }}>Principal Message</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span style={{ fontSize: '0.9rem', fontWeight: 800, textTransform: 'uppercase', color: 'var(--accent-purple)', letterSpacing: '1.5px' }}>Nurturer in Chief</span>
            <h2 style={{ fontSize: '2.5rem', color: 'var(--text-primary)', marginTop: '8px', marginBottom: '24px', fontFamily: 'Poppins' }}>Principal's Message</h2>
            <h4 style={{ fontSize: '1.25rem', color: 'var(--primary-dark)', fontWeight: 800, fontFamily: 'Poppins', marginBottom: '16px' }}>“Keep Going, Keep Growing”</h4>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8', fontSize: '1.05rem', marginBottom: '14px', fontFamily: 'Quicksand', fontWeight: 700 }}>
              More than just a motto, it defines our commitment to fostering growth, unlocking potential, and guiding students toward success. Through a well-rounded curriculum and engaging co-curricular activities, we create an environment where learning is dynamic and development is continuous. At Vamshee Techno School, every student matters, and every step forward counts.
            </p>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8', fontSize: '1.05rem', marginBottom: '14px', fontFamily: 'Quicksand', fontWeight: 700 }}>
              In this sensitive task of educating children, the parents also have a responsible role to play. Triangular efforts will be helpful for the complete development of the child.
            </p>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8', fontSize: '1.05rem', marginBottom: '14px', fontFamily: 'Quicksand', fontWeight: 700 }}>
              A dream is a hope or aspiration or something you desire and requires no effort. Aim is a direction towards a goal or purpose and requires effort. Always make your children to understand that there is only one difference between dream and aim. Dream requires sound sleep and aim requires sleepless efforts to fulfil. Choice is yours to make and I am sure that the education imparted in our school would help you make a wise choice. Aim higher and our school will help you to scale higher peaks of excellence.
            </p>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8', fontSize: '1.05rem', marginBottom: '20px', fontFamily: 'Quicksand', fontWeight: 700 }}>
              This website serves as a digital hub for students and parents, providing easy access to important documents such as notices, book lists, fee structures, admission forms, and more. It also features a gallery showcasing school events, functions, and activities, along with links to albums and YouTube videos.
            </p>
            <a href="/Admissions" className="btn-premium btn-premium-secondary" style={{ marginTop: '8px', display: 'inline-flex' }}>
              Admissions Walkthrough <ChevronRight size={16} />
            </a>
          </motion.div>
        </div>
      </section>

      {/* SVG Transition Wave 2 (Transitions to Peach for About) */}
      <div style={waveWrapperStyle}>
        <svg viewBox="0 0 1440 120" style={svgStyle} preserveAspectRatio="none">
          <path d="M0,64L120,58.7C240,53,480,43,720,53C960,64,1200,96,1320,112L1440,128L1440,120L1320,120C1200,120,960,120,720,120C480,120,240,120,120,120L0,120Z" fill="#ffe4e6"></path>
        </svg>
      </div>

      {/* 3. About Section (Soft Peach Background) */}
      <section id="about-section" style={{ ...sectionStyle, background: 'var(--bg-about)', paddingTop: '40px' }}>

        {/* Floating Butterfly and crayon decor */}
        <div style={{ position: 'absolute', top: '15%', right: '15%', fontSize: '2.5rem', opacity: 0.2 }} className="float-slow">🦋</div>
        <div style={{ position: 'absolute', bottom: '15%', left: '10%', fontSize: '2rem', opacity: 0.15 }}>🖍️</div>

        <div className="page-container-wide">
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ textAlign: 'center', marginBottom: '60px' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 800, color: 'var(--accent-coral)', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Learn About VTS</span>
            <h2 style={{ fontSize: '2.5rem', color: 'var(--text-primary)', marginTop: '8px', fontFamily: 'Poppins' }}>Our Creative Campus Atmosphere</h2>
          </motion.div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '72px' }}>
            {!Array.isArray(homeImages) || homeImages.length === 0 ? (
              <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Preparing school content...</p>
            ) : (
              homeImages.map((sec, idx) => (
                <motion.div key={idx} initial={{ opacity: 0, x: idx % 2 === 0 ? -50 : 50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.7 }} style={{ display: 'flex', flexWrap: 'wrap', gap: '48px', alignItems: 'center', flexDirection: idx % 2 === 0 ? 'row' : 'row-reverse' }}>
                  <div style={{ flex: '1 1 450px' }}>
                    <div style={{ borderRadius: 'var(--border-radius-img)', overflow: 'hidden', boxShadow: '0 20px 48px rgba(251,113,133,0.15)', border: '10px solid #ffffff' }} className={idx % 2 === 0 ? "organic-mask-1" : "organic-mask-2"}>
                      <img src={sec.imageLink} alt="About Section Layout" style={{ width: '100%', height: '400px', objectFit: 'cover', display: 'block' }} />
                    </div>
                  </div>
                  <div style={{ flex: '1 1 450px' }}>
                    <span style={{ fontSize: '0.8rem', fontWeight: 800, color: idx % 2 === 0 ? 'var(--primary-dark)' : 'var(--accent-purple)', textTransform: 'uppercase', letterSpacing: '1px' }}>Montessori Category</span>
                    <h3 style={{ fontSize: '2rem', color: 'var(--text-primary)', margin: '12px 0 20px', fontFamily: 'Poppins', fontWeight: 800 }}>
                      {idx === 0 ? "Tactile Montessori Learning & Crafting" : "Outdoor Play, Sensory Pools & Sports"}
                    </h3>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.8', fontSize: '1.15rem', fontFamily: 'Quicksand', fontWeight: 700 }}>
                      {sec.description}
                    </p>
                  </div>
                </motion.div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* SVG Transition Wave 3 (Transitions to Cyan for Academics) */}
      <div style={waveWrapperStyle}>
        <svg viewBox="0 0 1440 120" style={svgStyle} preserveAspectRatio="none">
          <path d="M0,96L120,80C240,64,480,32,720,32C960,32,1200,64,1320,80L1440,96L1440,120L1320,120C1200,120,960,120,720,120C480,120,240,120,120,120L0,120Z" fill="#ecfeff"></path>
        </svg>
      </div>

      {/* 4. Academics Programs Section (Sky Blue Background) */}
      <section style={{ ...sectionStyle, background: 'var(--bg-academics)', paddingTop: '40px' }}>

        {/* Floating Book & Graduation Cap decor */}
        <div style={{ position: 'absolute', top: '10%', left: '8%', fontSize: '2.5rem', opacity: 0.15 }} className="float-slow">📖</div>
        <div style={{ position: 'absolute', bottom: '15%', right: '10%', fontSize: '3rem', opacity: 0.15 }} className="sun-spin">🎓</div>

        <div className="page-container-wide">
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 800, color: 'var(--primary-dark)', textTransform: 'uppercase', letterSpacing: '1px' }}>Curriculum Guidelines</span>
            <h2 style={{ fontSize: '2.5rem', color: 'var(--text-primary)', fontFamily: 'Poppins' }}>Child Developmental Programs</h2>
            <p style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '12px auto 0', fontWeight: 700 }}>Curriculums mapped according to age-based sensory, counting and writing milestones.</p>
          </motion.div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '30px' }}>
            {[
              { stage: "Pre-Nursery & Nursery", desc: "Sensory development, voice matching, matching colors/numbers, and basic speech.", icon: "🎨", border: 'var(--accent-coral)' },
              { stage: "KG-I & KG-II", desc: "Writing foundation, alphabet loops, reading phonic loops, and basic math calculations.", icon: "🧩", border: 'var(--secondary-color)' },
              { stage: "Class I – V", desc: "Comprehensive primary subjects focusing on morality, cognitive reasoning and sciences.", icon: "🔬", border: 'var(--accent-green)' }
            ].map((cur, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ boxShadow: '0 20px 40px rgba(96,165,250,0.12)' }}
                style={{ backgroundColor: '#ffffff', borderRadius: 'var(--border-radius-card)', border: '1px solid var(--border-color)', display: 'flex', flexDirection: 'column', overflow: 'hidden', height: '100%', borderTop: `8px solid ${cur.border}` }}
              >
                <div style={{ padding: '40px 32px', flexGrow: 1, display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <div style={{ fontSize: '3.5rem', margin: 0 }}>{cur.icon}</div>
                  <h3 style={{ fontSize: '1.5rem', color: 'var(--text-primary)', margin: 0, fontFamily: 'Poppins', fontWeight: 800 }}>{cur.stage}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '1.02rem', lineHeight: '1.7', margin: 0, fontFamily: 'Quicksand', fontWeight: 600 }}>{cur.desc}</p>
                </div>
                <div style={{ padding: '24px 32px', backgroundColor: '#fcfdfd', borderTop: '1px solid var(--border-color)', display: 'flex', justifyContent: 'flex-end' }}>
                  <a href="/Academics" style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--primary-dark)', fontWeight: 800, textDecoration: 'none', fontSize: '0.95rem' }}>
                    Syllabus detail <ChevronRight size={16} />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* SVG Transition Wave 4 (Transitions to Green for Facilities) */}
      <div style={waveWrapperStyle}>
        <svg viewBox="0 0 1440 120" style={svgStyle} preserveAspectRatio="none">
          <path d="M0,32L60,42.7C120,53,240,75,360,74.7C480,75,600,53,720,48C840,43,960,53,1080,58.7C1200,64,1320,64,1380,64L1440,64L1440,120L1380,120C1320,120,1200,120,1080,120C960,120,840,120,720,120C600,120,480,120,360,120C240,120,120,120,60,120L0,120Z" fill="#f0fdf4"></path>
        </svg>
      </div>

      {/* 5. Facilities Section (Mint Green Background) */}
      <section style={{ ...sectionStyle, background: 'var(--bg-facilities)', paddingTop: '40px' }}>

        {/* Floating Sunshine & cloud shadows */}
        <div style={{ position: 'absolute', top: '15%', right: '5%', fontSize: '3.5rem', opacity: 0.15 }} className="sun-spin">☀️</div>
        <div style={{ position: 'absolute', bottom: '10%', left: '8%', fontSize: '2.5rem', opacity: 0.2 }} className="cloud-float">☁️</div>

        <div className="page-container-wide">
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 800, color: 'var(--success-color)', textTransform: 'uppercase', letterSpacing: '1px' }}>Modern Infrastructure</span>
            <h2 style={{ fontSize: '2.5rem', color: 'var(--text-primary)', fontFamily: 'Poppins' }}>Our Child-Friendly Playrooms</h2>
            <p style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '12px auto 0', fontWeight: 700 }}>Tactile Montessori spaces designed for visual memory, art and sensory development.</p>
          </motion.div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '24px' }}>
            {facilities.map((fac, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.12 }}
                whileHover={{ scale: 1.02 }}
                style={{ padding: '40px 32px', borderRadius: 'var(--border-radius-card)', border: '1px solid var(--border-color)', backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '20px', boxShadow: 'var(--shadow-md)' }}
              >
                <div style={{ fontSize: '3.5rem', margin: 0 }}>{fac.icon}</div>
                <h4 style={{ margin: 0, fontSize: '1.35rem', color: 'var(--text-primary)', fontFamily: 'Poppins', fontWeight: 800 }}>{fac.name}</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.98rem', lineHeight: '1.6', margin: 0, fontFamily: 'Quicksand', fontWeight: 600 }}>{fac.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* SVG Transition Wave 5 (Transitions directly to Soft Orange for Admissions) */}
      <div style={waveWrapperStyle}>
        <svg viewBox="0 0 1440 120" style={svgStyle} preserveAspectRatio="none">
          <path d="M0,96L120,80C240,64,480,32,720,32C960,32,1200,64,1320,80L1440,96L1440,120L1320,120C1200,120,960,120,720,120C480,120,240,120,120,120L0,120Z" fill="#fff7ed"></path>
        </svg>
      </div>

      {/* 6. Admissions Stepper / Form Section (Soft Orange Background) */}
      <section style={{ ...sectionStyle, background: 'var(--bg-admissions)', paddingTop: '40px' }}>

        {/* Floating Clouds decor */}
        <div style={{ position: 'absolute', top: '8%', right: '10%', fontSize: '2.5rem', opacity: 0.2 }} className="cloud-float">☁️</div>
        <div style={{ position: 'absolute', bottom: '15%', left: '8%', fontSize: '3rem', opacity: 0.15 }} className="float-slow">🎈</div>

        <div className="page-container-wide">
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 800, color: 'var(--accent-coral)', textTransform: 'uppercase', letterSpacing: '1px' }}>Quick Registration</span>
            <h2 style={{ fontSize: '2.5rem', color: 'var(--text-primary)', fontFamily: 'Poppins' }}>How to Join VTS family</h2>
            <p style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '12px auto 0', fontWeight: 700 }}>Follow these simple registration steps to secure classroom seating for 2026-27.</p>
          </motion.div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', marginBottom: '48px' }}>
            {[
              { num: "01", title: "Submit Online Request", desc: "Fill in student personal details, previous school history and guardian info.", color: 'var(--primary-color)' },
              { num: "02", title: "Verify Credentials", desc: "Submit birth certificate copy, Aadhaar copy and previous marks reports.", color: 'var(--accent-purple)' },
              { num: "03", title: "Interaction Meeting", desc: "A brief welcoming interaction between parent, child and principal.", color: 'var(--accent-coral)' },
              { num: "04", title: "Confirm Enrollment", desc: "Secure receipt and admission code to confirm classroom seating.", color: 'var(--accent-green)' }
            ].map((step, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.12 }}
                style={{ backgroundColor: '#ffffff', padding: '32px 24px', borderRadius: 'var(--border-radius-card)', border: '1px solid var(--border-color)', boxShadow: 'var(--shadow-md)', borderTop: `6px solid ${step.color}` }}
              >
                <div style={{ fontSize: '1.5rem', fontWeight: 800, color: step.color, backgroundColor: 'var(--bg-color)', width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px', border: `2px solid ${step.color}` }}>
                  {step.num}
                </div>
                <h4 style={{ fontSize: '1.25rem', color: 'var(--text-primary)', marginBottom: '8px', fontFamily: 'Poppins', fontWeight: 800 }}>{step.title}</h4>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', lineHeight: '1.5', margin: 0, fontFamily: 'Quicksand', fontWeight: 600 }}>{step.desc}</p>
              </motion.div>
            ))}
          </div>

          {/* CTA Box */}
          <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }} style={{ backgroundColor: 'var(--primary-color)', color: '#ffffff', padding: '40px', borderRadius: 'var(--border-radius-card)', textAlign: 'center', boxShadow: 'var(--shadow-premium)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px', position: 'relative', overflow: 'hidden' }}>
            <h3 style={{ color: '#ffffff', fontSize: '2rem', marginBottom: '4px', fontFamily: 'Poppins', fontWeight: 800 }}>Enroll Your Child Today!</h3>
            <p style={{ color: '#f0fdf4', maxWidth: '600px', margin: '0 auto', fontSize: '1.1rem', fontWeight: 700 }}>
              Use our simple online form to apply for registrations directly.
            </p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '8px' }}>
              <a href="/Apply" className="btn-premium btn-premium-secondary" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
                Online Application Form <ArrowRight size={18} />
              </a>
              <a href="tel:8982397404" className="btn-premium btn-premium-outline" style={{ border: '2px solid #ffffff', color: '#ffffff', textDecoration: 'none' }}>
                Call Helpline Support
              </a>
            </div>
          </motion.div>
        </div>
      </section>


    </div>
  );
}

// Styling Constants
const sectionStyle = {
  padding: '100px 0',
  position: 'relative',
  overflow: 'hidden'
};

const waveWrapperStyle = {
  position: 'relative',
  width: '100%',
  height: '60px',
  overflow: 'hidden',
  marginTop: '-60px',
  zIndex: 10
};

const svgStyle = {
  width: '100%',
  height: '100%',
  display: 'block'
};

const floatingBusStyle = {
  position: 'absolute',
  bottom: '10%',
  left: '-10%',
  backgroundColor: 'var(--primary-color)',
  color: '#ffffff',
  padding: '10px 20px',
  borderRadius: '20px',
  boxShadow: 'var(--shadow-md)',
  fontWeight: 800,
  fontSize: '0.88rem',
  animation: 'busMove 15s linear infinite',
  zIndex: 10
};


// Add standard bus animation styles
const busStyles = document.createElement('style');
busStyles.innerHTML = `
  @keyframes busMove {
    0% { left: -100px; }
    50% { left: 45%; }
    100% { left: 110%; }
  }
`;
document.head.appendChild(busStyles);
